import { AddRemittanceContext } from '../../../../../components/Purchasing/Remittance/AddRemittance/AddRemittanceCont'
import RemittanceLinesForm from '../../../../../components/Purchasing/Remittance/AddRemittance/Lines/RemittanceLinesForm'
import React from 'react'
import { Modal } from 'antd'
import FooterButtons from '../../../../../elements/Buttons/FooterButtons'

function RemittanceLinesModal(props) {
  const {
    removeLine,
    submit,
    updateLine,
    visible,
    modalType,
    formRefLine,
    onCancel,
    removingLine,
    submittingLine,
  } = React.useContext(AddRemittanceContext)

  const isNew = modalType === 'new'
  return (
    <Modal
      visible={visible}
      title={'Remittance Lines'}
      onCancel={onCancel}
      destroyOnClose={true}
      footer={
        <FooterButtons
          submit={submit}
          remove={removeLine}
          update={updateLine}
          removing={removingLine}
          submitting={submittingLine}
          title={'Lines'}
          isNew={isNew}
          isEdit={!isNew}
        />
      }
      width={'75%'}>
      <RemittanceLinesForm ref={formRefLine} {...props} />
    </Modal>
  )
}

RemittanceLinesModal.propTypes = {}
RemittanceLinesModal.defaultProps = {}

export default RemittanceLinesModal
